<route>
{
  "name": "members",
  "meta": {
    "order": 1,
    "isVisible": true,
    "iconName": "mdi-account-group-outline"
  }
}
</route>

<template>
  <div>
    <page-title
      :title="$t('pages.members.title')">
      <v-btn
        outlined
        :to="{name: 'memberAdd'}"
        color="success">
        {{$t('general.add')}}
      </v-btn>
    </page-title>
    <v-row
      v-if="!pageDataIsReady"
      >
      <v-col
        cols="12">
        <v-skeleton-loader
          type="table"
          ></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-data-table
      v-if="pageDataIsReady"
      class="report-table"
      :headers="headers"
      :items="courseList"
      disable-sort
    >
      <template v-slot:item.actions="{ item }">
        <v-row class="flex-nowrap">
          <v-col cols="6" class="px-0">
            <v-btn
              icon
              color="primary"
              :to="{ name: 'memberEdit', params: { id: item._id.$oid } }">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item._id="{ item }">
        <div class="english-number">
          <pre> {{ item._id.$oid }} </pre>
        </div>
      </template>
      <template slot="item.image" slot-scope="props">
          <router-link 
            v-if="props && props.item._id"
            :to="{ name: 'memberEdit', params: { id: props.item._id.$oid } }">
            <v-avatar
              color="indigo"
              size="36"
              >
              <span class="white--text subtitle-2">
                {{ props.item.name.charAt(0) }}
              </span>
            </v-avatar>
          </router-link>
      </template>
      <template v-slot:item.isadmin="{ item }">
        <v-icon 
          color="green"
          v-if="item.isadmin">
           mdi-check-circle-outline
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'pageCourseList',
  layout: APP_CONFIG.layout.mainPanelLayout,
  data () {
    return {
      pageDataIsReady: false,
      imageHeight: '150',
      col: '6',
      courseList: [],
      cardAnswerCount: null,
      badge: {
        medal: '/img/certificate.png'
      }
    }
  },
  computed: {
    headers () {
      return [
        {
          text: '', 
          value: 'image'
        },
        {
          text: this.$t('models.name'),
          value: 'name'
        },
        {
          text: this.$t('models.phone'),
          value: 'phone'
        },
        {
          text: this.$t('models.isadmin'),
          width: 100,
          value: 'isadmin'
        },
        {
          text: '',
          width: 48,
          value: 'actions'
        },
      ]
    },
  },
  mounted () {
    this.$store.dispatch('member/getMembers').then((response) => {
      this.courseList = response.data
      this.pageDataIsReady = true
    })
  }
}
</script>
